import { DEBUGGER } from "@/helper/helper";
import { payment } from "@/services/payment";
import { useMutation, useQueryClient } from "react-query";
const useApplyDiscount = () => {
  const queryClient = useQueryClient();
  const {
    mutateAsync: applyDiscount,
    isLoading: isLoadingDiscount,
    isSuccess
  } = useMutation(() => payment.applyDiscount(), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(["PRICING"]);
      queryClient.refetchQueries(["PRICING"]);
    },
    onError: error => {
      DEBUGGER("Error applying discount => ", error);
    }
  });
  return {
    applyDiscount,
    isLoadingDiscount,
    isSuccess
  };
};
export default useApplyDiscount;